import { WorkdayEmployeeUpdateFailures } from './WorkdayEmployeeUpdateFailures'

export const diagnosticsRoutes = [
  {
    path: '/diagnostics/workday/employee_updates/failures',
    element: <WorkdayEmployeeUpdateFailures />,
  },
]
